import { AdminPage } from "../_shared"; export default function Page(){return <AdminPage title="Coupons" />;}
